module.exports = __webpack_public_path__ + "img/报表查看权限.439dc64d.svg";